import { STATUS_REASON_TYPES, ORDER_CLOSURE_REASONS } from 'constants/AppConstants';

export default async () => {
  try {
    const response = await fetch(`${ORDER_CLOSURE_REASONS}?statusReasonType=${STATUS_REASON_TYPES.CustomerClosures}`);

    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };

    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
